"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationType = exports.PaginationTrigger = void 0;
var PaginationTrigger;
(function (PaginationTrigger) {
    PaginationTrigger["PageNr"] = "pageNr";
    PaginationTrigger["Prev"] = "prev";
    PaginationTrigger["Next"] = "next";
})(PaginationTrigger = exports.PaginationTrigger || (exports.PaginationTrigger = {}));
var PaginationType;
(function (PaginationType) {
    PaginationType["Default"] = "default";
    PaginationType["Compact"] = "compact";
    PaginationType["Input"] = "input";
})(PaginationType = exports.PaginationType || (exports.PaginationType = {}));
//# sourceMappingURL=Pagination.types.js.map